import * as Cookies from 'es-cookie';
import ISimpleEvent from '../events/ISimpleEvent';
import SimpleEvent from '../events/SimpleEvent';

export default class AuthHelper {
  private static readonly AuthCookieName: string = 'EngineCompartmentAuth';
  private static readonly GlobalPermissionsCookieName: string = 'EngineCompartmentGlobalPermissions';
  private static readonly ProjectPermissionsCookieName: string = 'EngineCompartmentProjectPermissions';
  private static readonly onChangeEventDispatcher = new SimpleEvent<void>();

  public static setGlobalPermissions(globalPermissions: string): void {
    Cookies.set(AuthHelper.GlobalPermissionsCookieName, globalPermissions);

    this.onChangeEventDispatcher.trigger();
  }

  public static getGlobalPermissions(): string | undefined {
    return Cookies.get(AuthHelper.GlobalPermissionsCookieName);
  }

  public static setProjectPermissions(projectPermissions: string): void {
    Cookies.set(AuthHelper.ProjectPermissionsCookieName, projectPermissions);

    this.onChangeEventDispatcher.trigger();
  }

  public static getProjectPermissions(): string | undefined {
    return Cookies.get(AuthHelper.ProjectPermissionsCookieName);
  }

  public static setAccessToken(token: string, expirationSeconds: Date): void {
    Cookies.set(AuthHelper.AuthCookieName, token, {expires: expirationSeconds});

    this.onChangeEventDispatcher.trigger();
  }

  public static getAccessToken(): string | undefined {
    return Cookies.get(AuthHelper.AuthCookieName);
  }

  public static isTokenSet(): boolean {
    let token = AuthHelper.getAccessToken();

    return token !== undefined && token !== null && token !== '';
  }

  public static removeSession() {
    Cookies.remove(this.AuthCookieName);
    Cookies.remove(this.GlobalPermissionsCookieName);
    Cookies.remove(this.ProjectPermissionsCookieName);

    let today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    AuthHelper.setAccessToken('', yesterday);
  }

  public static get onChange(): ISimpleEvent<void> {
    return this.onChangeEventDispatcher;
  }
}